var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDomain({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6665 2C1.56194 2 0.666504 2.89543 0.666504 4V6.66667C0.666504 7.77127 1.56194 8.66667 2.6665 8.66667H13.3332C14.4378 8.66667 15.3332 7.77127 15.3332 6.66667V4C15.3332 2.89543 14.4378 2 13.3332 2H2.6665ZM13.3332 3.33333H2.6665C2.29832 3.33333 1.99984 3.63181 1.99984 4V6.66667C1.99984 7.03487 2.29832 7.33333 2.6665 7.33333H13.3332C13.7014 7.33333 13.9998 7.03487 13.9998 6.66667V4C13.9998 3.63181 13.7014 3.33333 13.3332 3.33333ZM4.6665 13.3333C4.6665 12.9651 4.96498 12.6667 5.33317 12.6667H10.6665C11.0347 12.6667 11.3332 12.9651 11.3332 13.3333C11.3332 13.7015 11.0347 14 10.6665 14H5.33317C4.96498 14 4.6665 13.7015 4.6665 13.3333ZM2.6665 10.6667C2.6665 10.2985 2.96498 10 3.33317 10H12.6665C13.0347 10 13.3332 10.2985 13.3332 10.6667C13.3332 11.0349 13.0347 11.3333 12.6665 11.3333H3.33317C2.96498 11.3333 2.6665 11.0349 2.6665 10.6667Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomain);
export default __webpack_public_path__ + "static/media/domain.537ad7a71f217a92b30cfc191e4bff91.svg";
export { ForwardRef as ReactComponent };